import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { AuthHistoryDispatchTypes } from "../models/DispatchTypes/AllPatientRecord";
import { ApplicationState } from "../store/ApplicationState";
import { AuthorizationHistoryDispatchTypes } from "../constants/Authorization";
import { GetAuthHistory, GetDisciplineDetails, GetDisciplines } from "../services/Authorization";
import { DisciplineDispatchTypes } from "../models/DispatchTypes/Authorization";
import { DisciplineActionDispatchTypes, DisciplineDetailsActionDispatchTypes } from "../constants/Disciplines";
import { baseUrl  } from "../constants/Config";
import { AuthAndEligibilityHistoryPayload, DisciplinePayload } from "../models/Authorization";
import { DisciplineDetailsDispatchTypes } from "../models/DispatchTypes/DesciplineDetails";

export const getAuthHistory: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AuthHistoryDispatchTypes
  >
> = (payload: AuthAndEligibilityHistoryPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AuthorizationHistoryDispatchTypes.GET_AUTH_HISTORY_INVOKE,
    });

    const response = await GetAuthHistory(
      baseUrl ,
      payload
    );
    dispatch({
      response: response,
      type: AuthorizationHistoryDispatchTypes.GET_AUTH_HISTORY_SUCCESS,
    });
  };
};

export const getDisciplineList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DisciplineDispatchTypes
  >
> = (payload: DisciplinePayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DisciplineActionDispatchTypes.DISCIPLINE_INVOKE,
    });

    const response = await GetDisciplines(
      baseUrl ,
      payload
    );
    dispatch({
      response: response,
      type: DisciplineActionDispatchTypes.DISCIPLINE_SUCCESS,
    });
  };
};

export const getDisciplineDetails: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DisciplineDetailsDispatchTypes
  >
> = (serviceRequestDisciplineId : number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DisciplineDetailsActionDispatchTypes.GET_DISCIPLINE_DETAILS_INVOKE,
    });

    const response = await GetDisciplineDetails(
      baseUrl ,
      serviceRequestDisciplineId
    );
    dispatch({
      response: response,
      type: DisciplineDetailsActionDispatchTypes.GET_DISCIPLINE_DETAILS_SUCCESS,
    });
  };
};